import { Box, Skeleton } from "@mui/material";
import ComplianceAreaWrapper from "./complianceAreaWrapper/ComplianceAreaWrapper.tsx";
import React from "react";

export interface TopPaperComplianceAreasWrapperProps {
    isLoading: boolean;
    complianceAreas: Array<string>;
}

function TopPaperComplianceAreasWrapper(props: TopPaperComplianceAreasWrapperProps) {
    return props.isLoading ? (
        <Skeleton variant="text" width={"100%"} />
    ) : (
        <Box sx={{ display: "flex", justifyContent: "center", flexWrap: "wrap", gap: 1 }}>
            {props.complianceAreas.map((c) => (
                <ComplianceAreaWrapper key={c} complianceArea={c} noMargin />
            ))}
        </Box>
    );
}

export default TopPaperComplianceAreasWrapper;
